import { Address } from 'viem';

import { EvmContractAddresses, EvmContractName } from '@repo/types-client';

import { evmContractAddresses } from '../data/evm-contract-addresses';

/**
 * Capitalizes the first letter of a contract name
 * @param {EvmContractName} contractName - The contract name to format
 * @returns {Capitalize<EvmContractName>} The contract name with first letter capitalized
 */
const formatContractName = (
  contractName: EvmContractName,
): Capitalize<EvmContractName> => {
  return `${(contractName[0] as string).toUpperCase()}${(contractName as string).slice(1)}` as Capitalize<EvmContractName>;
};

/**
 * Retrieves the contract name from a given Ethereum address
 * @param {Address} address - The Ethereum address to look up
 * @returns {Capitalize<EvmContractName>} The capitalized contract name associated with the address
 * @throws {undefined} Returns undefined if no matching contract is found
 */
export const getContractNameFromAddress = (
  address: Address,
): Capitalize<EvmContractName> => {
  // Search through contract addresses to find a match (case-insensitive)
  const contractName = Object.keys(
    evmContractAddresses as EvmContractAddresses,
  ).find(
    (key): key is EvmContractName =>
      evmContractAddresses[key as EvmContractName].toLowerCase() ===
      address.toLowerCase(),
  );
  if (!contractName) throw new Error('No matching contract found');
  return formatContractName(contractName);
};
